import { Checkbox, Chip, chipClasses } from '@mui/material';
import PropTypes from 'prop-types';

const UserTypeCheckbox = ({
  label,
  labelIcon,
  isCreateCampaign = false,
  disabled = false,
  onClick,
  onChange,
  ...props
}) => {
  const handleClick = e => {
    if (disabled) {
      e.preventDefault();
      return;
    }
    onClick?.(e);
  };

  const handleChange = (e, checked) => {
    if (disabled) {
      e.preventDefault();
      return;
    }
    onChange?.(e, checked);
  };

  return (
    <Checkbox
      sx={{
        padding: 0,
        ...(disabled && { pointerEvents: 'none' }),
      }}
      disableRipple
      disabled={disabled}
      onClick={handleClick}
      onChange={handleChange}
      checkedIcon={
        <UserTypeChip
          label={label}
          labelIcon={labelIcon}
          checked
          isCreateCampaign={isCreateCampaign}
          disabled={disabled}
        />
      }
      icon={
        <UserTypeChip label={label} labelIcon={labelIcon} isCreateCampaign={isCreateCampaign} disabled={disabled} />
      }
      inputProps={{ 'aria-label': label }}
      {...props}
    />
  );
};

UserTypeCheckbox.propTypes = {
  label: PropTypes.string,
  labelIcon: PropTypes.node,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  onChange: PropTypes.func,
};

const UserTypeChip = ({ checked, labelIcon, label, isCreateCampaign, disabled }) => {
  const createCampaignStyle = isCreateCampaign ? { borderWidth: '1px', borderColor: '#C3D0CB' } : {};
  return (
    <Chip
      sx={{
        minWidth: 61,
        [`&.${chipClasses.outlined}`]: {
          color: '#737373',
        },
        [`&.${chipClasses.filled}`]: {
          padding: '1px',
        },
        ...createCampaignStyle,
      }}
      color={checked ? 'primary' : 'default'}
      variant={checked ? 'filled' : 'outlined'}
      disabled={disabled}
      label={
        <div className='flex items-center'>
          {!isCreateCampaign && labelIcon}
          <span className='text-[14px] font-[Manrope] font-semibold'>{label}</span>
          {isCreateCampaign && labelIcon}
        </div>
      }
    />
  );
};

UserTypeChip.propTypes = {
  checked: PropTypes.bool,
  labelIcon: PropTypes.node,
  label: PropTypes.string,
  disabled: PropTypes.bool,
};

export default UserTypeCheckbox;
